import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';

export const VpHookFormWrapper = ({ children, onSubmit }) => {
  const form = useForm();

  return (
    <FormProvider {...form}>
      <form
        onSubmit={(e) => {
          e.stopPropagation();

          return form.handleSubmit(onSubmit)(e);
        }}
      >
        {children}
      </form>
    </FormProvider>
  );
};

VpHookFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default VpHookFormWrapper;



// WEBPACK FOOTER //
// ./src/vp-ui/wrappers/VpHookFormWrapper.jsx